<kiwi-tabs class="_whiteTabs" *ngIf="tabs" [tabs]="tabs | async"></kiwi-tabs>
<router-outlet></router-outlet>
